export const SURVIVOR_GAMEPLAY_EQUIVALENTS = {
  bound_by_obsession: 'object_of_obsession',
  down_to_the_last: 'sole_survivor',
  will_to_live: 'decisive_strike'
}

export function getSurvivorGameplayPerkId (perkId) {
  return SURVIVOR_GAMEPLAY_EQUIVALENTS[perkId] || perkId
}

export function areSurvivorGameplayEquivalents (firstPerkId, secondPerkId) {
  if (!firstPerkId || !secondPerkId) return false
  return getSurvivorGameplayPerkId(firstPerkId) === getSurvivorGameplayPerkId(secondPerkId)
}

export default SURVIVOR_GAMEPLAY_EQUIVALENTS
